import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'

/**
 * Send a stable per-browser id as `x-device-id`, so the backend can identify
 * the device from the request headers. Mirrors the web-app implementation.
 *
 * The id is a random UUID generated once and kept in localStorage, so it
 * survives reloads and logout. If storage is unavailable (private mode, blocked
 * site data) it falls back to an in-memory id for the lifetime of the tab.
 *
 * Registered as a global axios request interceptor so it covers every request
 * regardless of the GET/DELETE argument shape used by the caller.
 *
 * CORS note: `x-device-id` is a custom header, so cross-origin requests that
 * carry it are preflighted. Every service must allow `x-device-id` in
 * `Access-Control-Allow-Headers` or requests will fail at the preflight.
 */
export const DEVICE_ID_HEADER = 'x-device-id'
const DEVICE_ID_STORAGE_KEY = 'deviceId'

let memoryDeviceId = null

export const getDeviceId = () => {
  try {
    let deviceId = localStorage.getItem(DEVICE_ID_STORAGE_KEY)
    if (!deviceId) {
      deviceId = uuidv4()
      localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId)
    }
    return deviceId
  } catch {
    memoryDeviceId = memoryDeviceId || uuidv4()
    return memoryDeviceId
  }
}

axios.interceptors.request.use(config => ({
  ...config,
  headers: {
    ...(config.headers || {}),
    [DEVICE_ID_HEADER]: getDeviceId(),
  },
}))
